import C10CenterMessage from './C10CenterMessage';
import schema from './props-schema';
import getEmptyDefaultProps from 'shared/lib/getEmptyDefaultProps';

C10CenterMessage.schema = schema;
C10CenterMessage.defaultProps = getEmptyDefaultProps(schema.propsSchema);

export default C10CenterMessage;
